import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material'
import { TraceKeyResponseTypeEnum } from '@ulysses-inc/harami_api_client'
import { FC, useId } from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
import { TextFieldWithCounter } from 'src/components/textField/TextFieldWithCounter'
import { RESPONSE_TYPE_OPTIONS } from 'src/features/traceKeys/utils/responseTypeOptions'
import { TRACE_KEY_NAME_MAX_LENGTH } from 'src/features/traceKeys/utils/traceKeyConstants'

export type CreateTraceKeyFormData = {
  name: string
  responseType: TraceKeyResponseTypeEnum | undefined
}

type Props = {
  form: UseFormReturn<CreateTraceKeyFormData>
}

/**
 * 検索キー追加フォームコンポーネント
 */
export const CreateTraceKeyForm: FC<Props> = ({ form }) => {
  const { control } = form
  const nameInputId = useId()

  const renderValue = (value: TraceKeyResponseTypeEnum | undefined) => {
    if (!value) return null
    const option = RESPONSE_TYPE_OPTIONS.find(opt => opt.value === value)
    if (!option) return null
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        {option.icon}
        <span>{option.label}</span>
      </Stack>
    )
  }

  return (
    <Stack spacing={2} sx={{ padding: 3, maxWidth: 600, mx: 'auto' }}>
      <Stack spacing={1}>
        <Typography
          htmlFor={nameInputId}
          component="label"
          sx={{
            fontWeight: 'bold',
            display: 'block',
          }}
        >
          検索キー名
        </Typography>
        <Controller
          name="name"
          control={control}
          rules={{
            required: '検索キー名を入力してください',
          }}
          render={({ field, fieldState: { error } }) => (
            <TextFieldWithCounter
              id={nameInputId}
              {...field}
              maxLength={TRACE_KEY_NAME_MAX_LENGTH}
              fullWidth
              error={!!error}
              helperText={error?.message}
              variant="outlined"
              autoComplete="off"
            />
          )}
        />
      </Stack>

      <Stack spacing={1}>
        <Typography
          component="label"
          sx={{
            fontWeight: 'bold',
            display: 'block',
          }}
        >
          回答種別
        </Typography>
        <Controller
          name="responseType"
          control={control}
          rules={{ required: '回答種別を選択してください' }}
          render={({ field, fieldState: { error } }) => (
            <FormControl fullWidth error={!!error}>
              <Select
                {...field}
                renderValue={renderValue}
                sx={{ backgroundColor: 'white' }}
              >
                {RESPONSE_TYPE_OPTIONS.map(option => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{ fontSize: '16px' }}
                  >
                    <Stack direction="row" spacing={1} alignItems="center">
                      {option.icon}
                      <span>{option.label}</span>
                    </Stack>
                  </MenuItem>
                ))}
              </Select>
              {error && <FormHelperText>{error.message}</FormHelperText>}
              <FormHelperText error={false}>
                あとで変更することはできません
              </FormHelperText>
            </FormControl>
          )}
        />
      </Stack>
    </Stack>
  )
}
